import React, { useState } from "react";
import dayjs from "dayjs";
import NetaqInput from "./NetaqInput";
import ActionButton from "./ActionButton";
import { useTranslate } from "./TranslationText";
import { convertToCamelCase } from "../helper/convertToCamelCase";
import { filterButtonsContainer, filterCard, filterHeader, filterResetBtn, filterSubmitBtn } from "../common/cssclasses";
import NewActionButton from "./ActionButtons/NewActionButton";
import { toSafeISOString } from "../helper/timeUtils";

const MIN_COURSE_DATE = dayjs('2000-01-01');

const CoursesFilter = ({ onSubmit }) => {
  const [checker, setChecker] = useState(true);
  const { translate } = useTranslate();
  const [dateStartFrom, setDateStartFrom] = useState(null);
  const [dateStartTo, setDateStartTo] = useState(null);

  const [filterState, setFilterState] = useState({
    // Initial filter values
    coursTitle: "",
    coursecategory: "both",
    DateFrom: "",
    DateTo: "",
  });


  const handleChange = (event, input) => {
    if (!!input && input === "DateFrom") {
      let val = event;
      if (val && dayjs(val).isValid()) {
        if (dayjs(val).isAfter(dayjs(), 'day')) {
          val = dayjs();
        }
        if (dateStartTo && dayjs(val).isAfter(dayjs(dateStartTo), 'day')) {
          setDateStartTo(null);
          setFilterState(prev => ({
            ...prev,
            DateFrom: toSafeISOString(val) ?? "",
            DateTo: "",
          }));
          setDateStartFrom(val);
          return;
        }
      }
      setDateStartFrom(val);
      setFilterState(prev => ({
        ...prev,
        DateFrom: toSafeISOString(val) ?? "",
      }));
      return;
    }
    if (!!input && input === "DateTo") {
      let val = event;
      if (val && dayjs(val).isValid()) {
        if (dayjs(val).isAfter(dayjs(), 'day')) {
          val = dayjs();
        }
        if (dateStartFrom && dayjs(val).isBefore(dayjs(dateStartFrom), 'day')) {
          val = dateStartFrom;
        }
      }
      setDateStartTo(val);
      setFilterState(prev => ({
        ...prev,
        DateTo: toSafeISOString(val) ?? "",
      }));
      return;
    }
    const value = event.target.type == 'checkbox' ? event.target.checked : event.target.value
    setFilterState({
      ...filterState,
      [event.target.name]: value,
    });


  };

  const handleSubmit = (event) => {
    window.scrollTo(0, 0);
    event.preventDefault();
    onSubmit(filterState); // Pass filter state to News
  };
  const handleReset = (event) => {
    window.scrollTo(0, 0);

    setDateStartFrom(null)
    setDateStartTo(null)

    setFilterState({
      coursTitle: "",
      coursecategory: "all",
      DateFrom: "",
      DateTo: "",
    });
  };



  return (
    <form
      className={filterCard}
      onSubmit={handleSubmit}
      onReset={handleReset}
    >
      <h2 className={filterHeader}>{translate('web.simplesearch', 'Search')}</h2>
      <div className="mb-form-group">
        <NetaqInput
          name={'coursTitle'}
          label={translate("web.courseTitle", "Course Title")}
          key={"search"}
          placeholder={translate("web.courseTitle", "Course Title")}
          type={"text"}
          onChange={handleChange}
        />
      </div>

      <div className="row mb-form-group-last">
        <div className="col-6">
          <NetaqInput
            name={"DateFrom"}
            key={"DateFrom"}
            type={"date"}

            label={
              <>
                {translate("web.date", "Date")} {translate("web.from", "From")}
              </>
            }
            onChange={handleChange}
            value={dateStartFrom}
            minDate={MIN_COURSE_DATE}
            maxDate={dateStartTo && dayjs(dateStartTo).isBefore(dayjs(), 'day') ? dateStartTo : dayjs()}
          />
        </div>
        <div className="col-6">
          <NetaqInput
            name={"DateTo"}
            key={"DateTo"}
            type={"date"}
            label={
              <>
                {translate("web.date", "Date")} {translate("web.to", "To")}
              </>
            }
            onChange={handleChange}
            value={dateStartTo}
            minDate={dateStartFrom || MIN_COURSE_DATE}
            maxDate={dayjs()}
          />
        </div>
      </div>
      <div className={filterButtonsContainer}>
        <div className={filterResetBtn}>
          <NewActionButton
            key={"reset"}
            isButton
            classNames="btn-outline-secondary"

            type={"reset"}
            text={translate('web.reset', 'Reset')}
          />
        </div>
        <div className={filterSubmitBtn}>
          <NewActionButton
            isButton
            classNames="btn-danger"
            text={translate("web.search", "Search")}
            key={"apply"}
            type={"submit"}
          />
        </div>
      </div>
    </form>
  );
};

export default CoursesFilter;
